import React, { type ReactNode } from "react";
import cx from "classnames";
import styles from "./Label.module.scss";

interface LabelProps {
	/** Label text */
	text: string;
	/** Label left icon */
	leftIcon?: ReactNode | undefined;
	/** Label right icon */
	rightIcon?: ReactNode | undefined;
	/** Custom label class name */
	className?: string;
	/** Custom style object */
	style?: object | undefined;
	/** Custom array for color types */
	variantsObject?: Record<ColorType, string[]> | undefined;
	/** Color variation */
	colorType?: string;
}

type ColorType =
	| "success"
	| "cancel"
	| "pending"
	| "info"
	| "neutral"
	| "default";

const getColorType = (
	inputString = "default",
	variants: Partial<Record<ColorType, string[]>> | undefined,
): ColorType => {
	if (inputString === "default") {
		return "default";
	}
	if (variants) {
		for (const [colorType, strings] of Object.entries(variants)) {
			if (strings.includes(inputString)) {
				return colorType as ColorType;
			}
		}
	}
	return "default";
};

export const Label = ({
	text,
	leftIcon,
	rightIcon,
	className,
	style = {},
	variantsObject,
	colorType,
}: LabelProps) => {
	return (
		<div
			className={cx(
				styles.label,
				styles[`${getColorType(colorType, variantsObject)}`],
				className,
				(leftIcon || rightIcon) && styles.withIcon,
				leftIcon && styles.withLeftIcon,
				rightIcon && styles.withRightIcon,
			)}
			style={style}
		>
			{leftIcon}
			{text}
			{rightIcon}
		</div>
	);
};
